import React from 'react';
import { Button } from 'antd';
import { hasFullAccess } from '@achievable-me/tundra-wizard/auth';
import CreateUserExam from '../CreateUserExam';
import ExamTiles from '../ExamTiles';
import ExamTile from '../ExamTile';

const FinraSieExams = ({ currentUser, disabled, product }) => {
  const cta = (() => {
    return hasFullAccess({ user: currentUser, product }) ? (
      <CreateUserExam productSlug={product.slug} />
    ) : (
      <Button disabled>Start exam</Button>
    );
  })();

  return (
    <ExamTiles>
      <ExamTile
        title="FINRA SIE"
        length="75 questions; 105 min"
        remaining={-1}
        iconClass="fad fa-user-chart"
        cta={cta}
        disabled={disabled}
      />
    </ExamTiles>
  );
};

export default FinraSieExams;
